import _ from "underscore";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";

export default class TreeNode {
    constructor(value, id) {
        this.value = value;
        this.id = !_.isUndefined(id) ? id : this.createId();
        this.level = 0;
        this.parent = null;
        this.children = [];
    }

    getParent() {
        return this.parent;
    }

    setParent(parent) {
        this.parent = parent;
    }

    _notifyChildAddedInDepth(child, root) {
        root._childAdded(child);
        const children = child.getChildren();
        for (let i = 0; i < children.length; i++)
            this._notifyChildAddedInDepth(children[i], root);
    }

    appendChild(child) {
        this.children.push(child);
        child.setParent(this);
        child.setLevel(this.level + 1);
        const root = this.getRoot();
        if (root)
            this._notifyChildAddedInDepth(child, root);
    }

    getChildren() {
        return this.children;
    }

    getValue() {
        return this.value;
    }

    getLevel() {
        return this.level;
    }

    setLevel(level) {
        return this.level = level;
    }

    hasChildren() {
        return this.children.length > 0;
    }

    getId() {
        return this.id;
    }

    getRoot() {
        return this.parent ? this.parent.getRoot() : null;
    }

    createId() {
        return HierarchySelectorUtil.makeTreeNodeId(this.getIdPrefix(), this.getIdIndex());
    }

    getIdPrefix() {
        // Abstract
    }

    getIdIndex() {
        return this.value ? this.value.id : 0;
    }

    getType() {
        // Abstract
    }

    isCollapsible() {
        return true;
    }
}

TreeNode.TYPE_DEFAULT = 0;
TreeNode.TYPE_CUSTOMER = 1;
TreeNode.TYPE_PROJECT = 2;
TreeNode.TYPE_GROUP = 3;
TreeNode.TYPE_USER = 4;
TreeNode.TYPE_DISABLED_USERS_PARENT = 5;
TreeNode.TYPE_ARCHIVED_PROJECTS_PARENT = 6;
TreeNode.TYPE_ARCHIVED_CUSTOMERS_PARENT = 7;



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/TreeNode.js